<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>头像定制</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <el-row style="padding-bottom: 10px;text-align: right;border-bottom: 1px solid #EDEDED;">
          <el-button type="primary" @click="addddd()">新增</el-button>
        </el-row>
        <el-table
          :data="dataa"
          align="left"
          style="width: 100%">
          <el-table-column
            label="详情页"
          >
            <template slot-scope="scope">
              <img :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+scope.row.url"
                   alt="" width="80"  height="80">
            </template>
          </el-table-column>

          <el-table-column
            label="价格"
            prop="price">
          </el-table-column>

          <el-table-column
            label="操作"
            width="170">
            <template slot-scope="scope">
              <el-button  @click="editvalue(scope.row)" size="small" type="text">修改</el-button>
              <el-button @click="changevaluestate(scope.row.img_id,0)" size="small" type="text">删除</el-button>
              <el-button @click="" size="small" type="text">确认</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin-top: 20px">

          <el-col :xs="24" :sm="24" :md="24" :lg="24" align="right">
            <el-pagination
              style="text-align: right"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="datatotal">
            </el-pagination>
          </el-col>
        </el-row>
      </el-row>

    </el-row>
    <el-dialog title="详情" :visible.sync="infoVisible" width="360px" :modal-append-to-body="false">
      <el-form label-position="left" class="demo-table-expand" label-width="108px" style="text-align: left">

        <el-form-item label="内容">
          <span>{{ infodata.introduction}}</span>
        </el-form-item>
        <!--<el-form-item label="课程详情:">-->
        <!--</el-form-item>-->
        <!--<div v-html="infodata.info"></div>-->
      </el-form>
    </el-dialog>
    <el-dialog title="新增" :visible.sync="addVisible" width="360px" :modal-append-to-body="false">
      <el-form :model="adddata" :rules="addrules" ref="adddata" style="text-align: left">

        <el-form-item label="价格" :label-width="formLabelWidth" prop="price">
          <el-input clearable v-model="adddata.price" auto-complete="off" placeholder="请输入" type="price"
                    required></el-input>
        </el-form-item>

        <el-form-item label="详情" :label-width="formLabelWidth" prop="url">
          <div class="oss_file">
            <input type="file" :id="addid" @change="adddoUpload" value="" accept="image/*"/>
            <div style="text-align: left">

              <img  :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+adddata.url" alt="" style="max-width: 50px">
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitadd('adddata')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑" :visible.sync="editVisible" width="360px" :modal-append-to-body="false">
      <el-form :model="editdata" :rules="editrules" ref="editdata" style="text-align: left">

        <el-form-item label="价格" :label-width="formLabelWidth" prop="price">
          <el-input clearable v-model="editdata.price" auto-complete="off" placeholder="请输入" type="number"
                    required></el-input>
        </el-form-item>
        <el-form-item label="详情" :label-width="formLabelWidth" prop="url">
          <div class="oss_file">
            <input type="file" :id="editid" @change="editdoUpload" value="" accept="image/*"/>
            <div style="text-align: left">
              <img v-if="editdata.url" :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+editdata.url" alt="" style="max-width: 50px">
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitedit('editdata')">确 定</el-button>
      </div>
    </el-dialog>

    <template><span v-loading.fullscreen.lock="fullscreenLoading"></span></template>
  </div>
</template>

<script>
  let Base64 = require('js-base64').Base64;
  export default {
    name: "HeadImg",
    computed: {
      userdata() {
        return this.$store.state.login.user
      },

    },
    mounted() {
      if (!this.$store.state.login.in) {
        this.$router.push({name: "login", params: {userId: 123}})
      }
      this.getstart()
    },
    data() {
      return {
        bucket : "txcsapp",
        region: "oss-cn-zhangjiakou",
        addid: 'addupload',
        editid: 'editupload',
        tags: [],
        inputVisible: false,
        inputValue: '',
        dataa: [],
        datatotal: 0,
        pagesize: 10,
        currentPage: 1,
        infoVisible: false,
        addVisible: false,
        editVisible: false,
        infodata: {},
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        activeName: '',
        fullscreenLoading: false,
        //表格
        formLabelWidth: '100px',
        adddata: {
          birthday: '',
          money_score: '',
          feeling_score: '',
          cause_score: '',
          price: '',
          oldprice: '',
          url:'',
        },
        addrules: {
          birthday:{required: true, message: '请选择生日', trigger: 'blur'},
          money_score: {required: true, message: '请输入', trigger: 'blur'},
          feeling_score: {required: true, message: '请输入', trigger: 'blur'},
          cause_score: {required: true, message: '请输入', trigger: 'blur'},
          price: {required: true, message: '请输入', trigger: 'blur'},
          oldprice: {required: true, message: '请输入', trigger: 'blur'},
          url: {required: true, message: '请上传', trigger: 'blur'},
        },
        editdata: {
          birthday: '',
          money_score: '',
          feeling_score: '',
          cause_score: '',
          price: '',
          oldprice: '',
          url:'',
        },
        editrules: {
          birthday:{required: true, message: '请选择生日', trigger: 'blur'},
          money_score: {required: true, message: '请输入', trigger: 'blur'},
          feeling_score: {required: true, message: '请输入', trigger: 'blur'},
          cause_score: {required: true, message: '请输入', trigger: 'blur'},
          price: {required: true, message: '请输入', trigger: 'blur'},
          oldprice: {required: true, message: '请输入', trigger: 'blur'},
          url: {required: true, message: '请上传', trigger: 'blur'},
        },
      }
    },
    watch: {},
    methods: {

      xx(row) {
        this.$router.push({name: 'audio', params: {row}})
      },
      adddoUpload () {
        const _this = this
        const urls = [];
        _this.$http.post('http://sts.txcsok.com/oss.php').then((result) => {
          const client = new OSS.Wrapper({
            region: _this.region,
            accessKeyId: result.data.AccessKeyId,
            accessKeySecret: result.data.AccessKeySecret,
            stsToken: result.data.SecurityToken,
            bucket: _this.bucket
          })
          _this.percentage = 0;
          const files = document.getElementById(_this.addid)
          if (files.files) {
            const fileLen = document.getElementById(_this.addid).files
            let resultUpload = ''
            for (let i = 0; i < fileLen.length; i++) {
              const file = fileLen[i]
              console.log(file);
              // 随机命名
              let random_name = 'headimg/'+ new Date().getTime()+this.random_string(6) + '_'  + '.' + file.name.split('.').pop()
              console.log(random_name);
              // 上传
              client.multipartUpload(random_name, file, {
                progress: function* (percentage, cpt) {
                  // 上传进度
                  _this.percentage = parseInt(percentage*100)
                }
              }).then((results) => {
                // 上传完成
                const url = results.name;
                _this.adddata.url = url;
                console.log(_this.adddata.url);
              }).catch((err) => {
                console.log(err)
              })
            }
          }
        })
      },
      editdoUpload () {
        const _this = this
        const urls = [];
        _this.$http.post('http://sts.txcsok.com/oss.php').then((result) => {
          const client = new OSS.Wrapper({
            region: _this.region,
            accessKeyId: result.data.AccessKeyId,
            accessKeySecret: result.data.AccessKeySecret,
            stsToken: result.data.SecurityToken,
            bucket: _this.bucket
          })
          _this.percentage = 0;
          const files = document.getElementById(_this.editid)
          if (files.files) {
            const fileLen = document.getElementById(_this.editid).files
            let resultUpload = ''
            for (let i = 0; i < fileLen.length; i++) {
              const file = fileLen[i]
              console.log(file);
              // 随机命名
              let random_name = 'headimg/'+ new Date().getTime()+this.random_string(6) + '_'  + '.' + file.name.split('.').pop()
              console.log(random_name);
              // 上传
              client.multipartUpload(random_name, file, {
                progress: function* (percentage, cpt) {
                  // 上传进度
                  _this.percentage = parseInt(percentage*100)
                }
              }).then((results) => {
                console.log('上传完成');
                // 上传完成
                const url = results.name;
                _this.editdata.url = url;
                console.log(url);
              }).catch((err) => {
                console.log(err)
              })
            }
          }
        })
      },

      // 随机生成文件名
      random_string(len) {
        len = len || 32;
        var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz';
        var maxPos = chars.length;
        var pwd = '';
        for (let i = 0; i < len; i++) {
          pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
      },
      Tags(tags){
        return tags.split(",")
      },
      details(row){
        let thi = this
        thi.infodata = JSON.parse(JSON.stringify(row));
        thi.infoVisible = true
      },
      gohref(name){
        this.$router.push({name:name})
      },
      addddd(){
        let thi = this
        thi.adddata ={
          birthday: '',
          money_score: '',
          feeling_score: '',
          cause_score: '',
          price: '',
          oldprice: '',
          url:'',
        }
        thi.addVisible = true
      },
      //修改
      editvalue(row) {
        this.editdata = JSON.parse(JSON.stringify(row))
        this.editVisible = true
      },
      submitadd(formName) {
        let thi=this
        console.log(thi.adddata)
        thi.$refs[formName].validate((valid) => {
          if (valid) {
            thi.fullscreenLoading = true
            thi.$http.post(global.posturl.host + global.posturl.imgAdd,
              thi.adddata
            ).then(function (response) {
              console.log(response.data)
              var qcode = response.data.code
              var qmsg = response.data.msg
              var qdata = response.data.data
              if (qcode == 200) {
                thi.addVisible = false
                thi.fullscreenLoading = false
                thi.getstart()
              } else {
                thi.$message({
                  type: 'warning',
                  message: qmsg
                });
                thi.fullscreenLoading = false
              }
            }).catch(function (error) {
              console.log(error)
            });

          } else {
            return false;
          }
        });
      },
      submitedit(formName) {
        let thi=this
        console.log(thi.editdata)
        thi.$refs[formName].validate((valid) => {
          if (valid) {
            if(thi.tags.length==0){
              thi.editdata.tags = ''
            }else {
              var tagss = '';
              thi.tags.forEach(function(avalue,aindex,aarr){
                if(aindex==0){
                  tagss = avalue
                  console.log(avalue)
                }else {
                  tagss = tagss+','+avalue
                }
              });
              thi.editdata.tags = tagss
            }
            thi.fullscreenLoading = true
            thi.$http.post(global.posturl.host + global.posturl.imgEdit,
              thi.editdata
            ).then(function (response) {
              console.log(response.data)
              var qcode = response.data.code
              var qmsg = response.data.msg
              var qdata = response.data.data
              if (qcode == 200) {
                thi.editVisible = false
                thi.fullscreenLoading = false
                thi.getstart()
              } else {
                thi.$message({
                  type: 'warning',
                  message: qmsg
                });
                thi.fullscreenLoading = false
              }
            }).catch(function (error) {
              console.log(error)
            });

          } else {
            return false;
          }
        });
      },
      handleClose(tag) {
        this.tags.splice(this.tags.indexOf(tag), 1);
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.tags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      },
      panduanleixing2(type) {
        switch (type) {
          case '1':
            return "";
            break;
          case '2':
            return "success";
            break;
          case '3':
            return "success";
            break;
          case '4':
            return "info";
            break;
          default:
            return null;
        }
      },

      //选择展示数量
      handleSizeChange(val) {
        this.pagesize = val
        this.getstart()
      },
      //跳转页面
      handleCurrentChange(val) {
        this.currentPage = val
        this.getstart()
      },
      getstart() {
        let thi = this
        thi.fullscreenLoading = true
        thi.$http.post(global.posturl.host + global.posturl.imgList, {
          birthday:'',
          page: thi.currentPage,
          pageSize: thi.pagesize
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if (qcode == 200) {
            thi.dataa = qdata
            thi.datatotal = qtotal
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },

      handleNodeClick(data) {
        console.log(data);
      },

      //删除提示
      changevaluestate(theme_id, state) {
        console.log(theme_id)
        var heeh = '该'
        var caozuo = '禁用'
        if (theme_id.length > 1) {
          heeh = '这些'
        }
        if (state == 0) {
          caozuo = '删除'
        }
        let thi = this
        thi.$confirm('此操作将' + caozuo + heeh + '账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          thi.submitchangestate(theme_id, state)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消' + caozuo
          });
        });
      },
      //状态改变(删除)
      submitchangestate(theme_id, state) {
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.imgStateChange, {
          img_id: theme_id,
          state: state,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },


      //格式化时间
      formatDate(date) {
        if (!date) {
          return "无"
        }
        Date.prototype.toLocaleString = function () {
          return this.getFullYear() + "年" + (this.getMonth() + 1) + "月" + this.getDate() + "日" + this.getHours() + "点" + this.getMinutes() + "分" + this.getSeconds() + "秒";
        };
        var unixTimestamp = new Date(date * 1000)
        return unixTimestamp.toLocaleString();
      },
      //状态改变（启用）
      changeArticleState(theme_id, state) {
        //方法传进来的，不用this.
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.audioThemeChange, {
          theme_id: theme_id,
          state: state
        }).then(function (response) {
          var qcode = response.data.code
          if (qcode == 200) {
            thi.getstart()
          }
        }).catch(function (error) {
          console.log(error)
        });
      },
    }
  }
</script>

<style scoped>
  .admin-body {
    /*background-color: white;*/
    width: 100%;
  }

  .main {
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }

  .block {
    text-align: left;
  }

  .el-select {
    width: 100%;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>



// WEBPACK FOOTER //
// src/page/article/Article.vue